export default __webpack_public_path__ + "static/media/duration.f97ff144.svg";